import { Link } from "react-router-dom";
import { ArrowRight, BookOpen, Clock } from "lucide-react";
import { ratgeberArticles } from "../data/ratgeberArticles";
import { ResponsiveImage } from "../components/ResponsiveImage";

export const Ratgeber = () => {
  return (
    <div className="bg-white" data-testid="ratgeber-page">
      <section className="bg-[#122A5C] pt-28 pb-16 text-white md:pt-36 md:pb-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <span className="mb-4 block text-xs font-bold uppercase tracking-[0.2em] text-[#F28A0D]">
              Ratgeber
            </span>
            <h1 className="font-heading mb-6 text-4xl font-bold leading-tight md:text-5xl">
              Wissen für Flächeneigentümer
            </h1>
            <p className="text-lg leading-relaxed text-white/75 md:text-xl">
              Orientierung zu Dachverpachtung, Batteriespeichern, Freiflächen-PV
              und kleinen Speicherflächen in Magdeburg, Sachsen-Anhalt und
              Deutschland.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid gap-6 md:grid-cols-2">
            {ratgeberArticles.map((article) => (
              <Link
                key={article.slug}
                to={`/ratgeber/${article.slug}`}
                className="group block overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm transition-all hover:border-[#E07000] hover:shadow-xl"
                data-testid={`ratgeber-card-${article.slug}`}
              >
                <div className="aspect-[16/9] overflow-hidden bg-slate-100">
                  <ResponsiveImage
                    src={article.image}
                    alt={article.imageAlt}
                    width={article.imageWidth}
                    height={article.imageHeight}
                    sizes="(min-width: 768px) 50vw, 100vw"
                    loading="lazy"
                    decoding="async"
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-6 md:p-8">
                  <div className="mb-4 flex flex-wrap items-center gap-3 text-sm text-slate-500">
                    <span className="inline-flex items-center gap-2 font-semibold text-[#E07000]">
                      <BookOpen className="h-4 w-4" />
                      {article.category}
                    </span>
                    <span className="inline-flex items-center gap-2">
                      <Clock className="h-4 w-4" />
                      {article.readingTime}
                    </span>
                  </div>
                  <h2 className="font-heading mb-3 text-2xl font-bold leading-tight text-[#122A5C]">
                    {article.title}
                  </h2>
                  <p className="mb-6 leading-relaxed text-slate-600">
                    {article.excerpt}
                  </p>
                  <span className="inline-flex items-center font-semibold text-[#122A5C] transition-colors group-hover:text-[#E07000]">
                    Artikel lesen
                    <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};
